export const validatePercentageValues = data => {
  const invalidPercentageValuesExist = data.some(([, value]) => value < 0);
  if (invalidPercentageValuesExist) {
    throw new TypeError('percent values must be greater than zero');
  }
};
